module.exports = __webpack_public_path__ + "static/blog-6-4094117fd538aa539981cc919b81f3d2.png";